import './css/MobileFirstIcons.css';
import { cn } from '../lib/utils';

export enum Icons {
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  ChevronDown = 'chevron-down',
  Cancel = 'cancel',
  Check = 'check',
  Ai = 'ai',
  Sun = 'sun',
  History = 'history',
  ArrowUp = 'arrow-up',
  ArrowDown = 'arrow-down',
  Share = 'share',
  Pause = 'pause',
  Play = 'play',
  PhoneFill = 'phone-fill',
  ChatBubbleFill = 'chat-bubble-fill',
  Reload = 'reload',
  Copy = 'copy',
  Like = 'like',
  Dislike = 'dislike',
  Stop = 'stop',
  Calendar = 'calendar',
  LikeFill = 'like-fill',
  DislikeFill = 'dislike-fill',
  PhoneInbound = 'phone-inbound',
  PhoneOutbound = 'phone-outbound',
  PhoneTransfer = 'phone-transfer',
  Plus = 'plus',
  Bin = 'bin',
  PaperPlane = 'paper-plane',
  ArrowSelect = 'arrow-select',
  Teams = 'teams',
  Speaker = 'speaker',
  PhoneTransferOutline = 'phone-transfer-outline',
  Danger = 'danger',
  Suitcase = 'suitcase',
  Newspaper = 'newspaper',
  Microphone = 'microphone',
  Integrations = 'integrations',
  DialPad = 'dial-pad',
  ContactsFill = 'contacts-fill',
  Contacts = 'contacts',
  Phone = 'phone',
  Settings = 'settings',
  Inbox = 'inbox',
  InboxFill = 'inbox-fill',
  ChatBubble = 'chat-bubble',
  DotsThree = 'dots-three',
  NotePencil = 'note-pencil',
  Star = 'star',
  StarFill = 'star-fill',
  Edit = 'edit',
  Prohibit = 'prohibit',
  Info = 'info',
  Minus = 'minus',
  MagnifyingGlass = 'magnifying-glass',
  Globe = 'globe',
  MapPin = 'map-pin',
  Moon = 'moon',
  Voicemail = 'voicemail',
  ContactsAdd = 'contacts-add',
  Status = 'status',
  StatusCheck = 'status-check',
  Tag = 'tag',
  TagCheck = 'tag-check',
  Diamond = 'diamond',
  EyeClose = 'eye-close',
  HeartBreak = 'heart-break',
  SimCard = 'sim-card',
  Download = 'download',
  SpeakerFill = 'speaker-fill',
  ArrowSquareOut = 'arrow-square-out',
  BuildingOffice = 'building-office',
  TextAlignLeft = 'text-align-left',
  PaperPlaneTilt = 'paper-plane-tilt',
  Waveform = 'waveform',
  Cube = 'cube',
  CircleQuarter = 'circle-quarter',
  CircleCross = 'circle-cross',
  CircleCheck = 'circle-check',
  CircleThreeQuarter = 'circle-three-quarter',
  CircleFull = 'circle-full',
  CircleHalf = 'circle-half',
  CircleQuestion = 'circle-question',
  CircleDot = 'circle-dot',
  CircleDashed = 'circle-dashed',
  ListDashes = 'list-dashes',
  SortAscending = 'sort-ascending',
  Sliders = 'sliders',
  User = 'user',
  CurrencyDollarSimple = 'currency-dollar-simple',
  Clock = 'clock',
  DotsSixVertical = 'dots-six-vertical',
  Translate = 'translate',
  Hash = 'hash',
  Avatar = 'avatar',
  ShieldWarningOutline = 'shield-warning-outline',
  ShieldWarningFill = 'shield-warning-fill',
  EnveloppeClosedFill = 'enveloppe-closed-fill',
  PhoneMissedCall = 'phone-missed-call',
  PhoneMissedCallOutline = 'phone-missed-call-outline',
  PadlockFill = 'padlock-fill',
  DeleteKey = 'delete-key',
  CreditCardFill = 'credit-card-fill',
  Cascade = 'cascade',
  Simultaneous = 'simultaneous',
  BellRinging = 'bell-ringing',
  Power = 'power',
  Archive = 'archive',
  DoubleCheck = 'double-check',
  Paste = 'paste',
  DotGrid = 'dot-grid',
  ChartLine = 'chart-line',
  ArrowLineLeft = 'arrow-line-left',
  PhoneDecline = 'phone-decline',
  ArrowUpRight = 'arrow-up-right',
  QrCode = 'qr-code',
  Funnel = 'funnel',
  PictureFill = 'picture-fill',
  CameraFill = 'camera-fill',
  FileFill = 'file-fill',
  EnveloppeOpenedFill = 'enveloppe-opened-fill',
  ArrowLeft = 'arrow-left',
  Link = 'link',
  AddressBook = 'address-book',
  Compass = 'compass',
  BracketsCurly = 'brackets-curly',
  Paperclip = 'paperclip',
  PostIt = 'post-it',
  Slash = 'slash',
  FolderOutline = 'folder-outline',
  FolderFill = 'folder-fill',
  Select = 'select',
  EyeOpen = 'eye-open',
  Asterisk = 'asterisk',
  Table = 'table',
  At = 'at',
  CameraOutline = 'camera-outline',
  FileUpload = 'file-upload',
  Crown = 'crown',
  Smiley = 'smiley',
  DangerFill = 'danger-fill',
  Dash = 'dash',
  Pulse = 'pulse',
  PhoneDeclineFill = 'phone-decline-fill',
  PhoneAi = 'phone-ai',
  DialPadFill = 'dial-pad-fill',
  Desktop = 'desktop',
  Mobile = 'mobile',
  MicrophoneSlash = 'microphone-slash',
  UserList = 'user-list',
  PhoneClick = 'phone-click',
  Ivr = 'ivr',
  SoundCard = 'sound-card',
  ContactsAddFill = 'contacts-add-fill',
  PhoneRouting = 'phone-routing',
  Lifebuoy = 'lifebuoy',
  Headset = 'headset',
  SlashInSquare = 'slash-in-square',
  CircleQuestionEmpty = 'circle-question-empty',
  Quotes = 'quotes',
  ArrowRight = 'arrow-right',
  PencilAi = 'pencil-ai',
  DottedClock = 'dotted-clock',
  Forward15 = 'forward-15',
  Back15 = 'back-15',
  Forward10 = 'forward-10',
  Back10 = 'back-10',
  MagicWand = 'magic-wand',
  PushPin = 'push-pin',
  Microscope = 'microscope',
  FunnelSimple = 'funnel-simple',
  FileOutline = 'file-outline',
  HandHeart = 'hand-heart',
  UserMinus = 'user-minus',
  UserPlus = 'user-plus',
  TextItalic = 'text-italic',
  TextB = 'text-b',
  TextUnderline = 'text-underline',
  TextStrikethrough = 'text-strikethrough',
  ListBullet = 'list-bullet',
  ListChecks = 'list-checks',
  ListNumbers = 'list-numbers',
  CodeBlock = 'code-block',
  Code = 'code',
  ShieldCheckFill = 'shield-check-fill',
  ShieldCheckOutline = 'shield-check-outline',
  BoltFill = 'bolt-fill',
  KeyOutline = 'key-outline',
  KeyFill = 'key-fill',
  ArrowDownLeft = 'arrow-down-left',
  DoubleChart = 'double-chart',
  TriangleDown = 'triangle-down',
  CrownFill = 'crown-fill',
  TriangleUp = 'triangle-up',
  TextH = 'text-h',
  VideoCamera = 'video-camera',
  ArrowLineRight = 'arrow-line-right',
  ShieldEmptyOutline = 'shield-empty-outline',
  Notification = 'notification',
  SortDescending = 'sort-descending',
  MoonOutline = 'moon-outline',
  ChatBubbleEmpty = 'chat-bubble-empty',
  PhoneCall = 'phone-call',
  List = 'list',
  SquaresFour = 'squares-four',
  DoubleCheckSplit = 'double-check-split',
  CircleWarningFilled = 'circle-warning-filled',
  CircleWarning = 'circle-warning',
  ArrowUpLeft = 'arrow-up-left',
  DotsSixHorizontal = 'dots-six-horizontal',
  IdentificationCard = 'identification-card',
  SpeakerSlash = 'speaker-slash',
  DotGridBolt = 'dot-grid-bolt',
  DotsThreeVertical = 'dots-three-vertical',
  PictureInPicture = 'picture-in-picture',
  Bolt = 'bolt',
  Columns = 'columns',
  Boolean = 'boolean',
  ArrowBendDownRight = 'arrow-bend-down-right',
  SidebarLeft = 'sidebar-left',
  PlayNext = 'play-next',
  Note = 'note',
  Routing = 'routing',
  HashArrow2 = 'hash-arrow-2',
  ArrowBendDownSquare = 'arrow-bend-down-square',
  BellMute = 'bell-mute',
  Browser = 'browser',
  TextToSpeech = 'text-to-speech',
  Database = 'database',
  CircleCheckEmpty = 'circle-check-empty',
  Store = 'store',
  Library = 'library',
  Duplicate = 'duplicate',
  ClockPlus = 'clock-plus',
  ChartBar = 'chart-bar',
  SidebarRight = 'sidebar-right',
  NotificationDot = 'notification-dot',
  CurveDownRight = 'curve-down-right',
  ChatBubbleAdd = 'chat-bubble-add',
  ChatBubbleAddFill = 'chat-bubble-add-fill',
  CurveDownLeft = 'curve-down-left',
  EnveloppeClosed = 'enveloppe-closed',
  EnveloppeOpened = 'enveloppe-opened',
  MusicNoteFill = 'music-note-fill',
  House = 'house',
  Hourglass = 'hourglass',
  Glove = 'glove',
  GraduationCap = 'graduation-cap',
  ForkKnife = 'fork-knife',
  UserAvatar = 'user-avatar',
  ArchiveFill = 'archive-fill',
  MicrophoneFill = 'microphone-fill',
  MicrophoneSlashFill = 'microphone-slash-fill',
  SpeakerSlashFill = 'speaker-slash-fill',
  SpeakerBluetoothFill = 'speaker-bluetooth-fill',
  SpeakerBluetooth = 'speaker-bluetooth',
  Discount = 'discount',
  Infinity = 'infinity',
  PieChart = 'pie-chart',
  Heading01 = 'heading-01',
  Heading02 = 'heading-02',
  Heading03 = 'heading-03',
  ListIndentIncrease = 'list-indent-increase',
  ListIndentDecrease = 'list-indent-decrease',
  Text = 'text',
  Webhook = 'webhook',
  Mcp = 'mcp',
  BadgeCheck = 'badge-check',
}

export interface IconInterface {
  name: Icons;
  className?: string;
}
export const Icon = ({ name, className }: IconInterface) => (
  // The icon-font glyph class (`name`, e.g. `text-h`, `text-italic`) is
  // appended *outside* of `cn()`. Routing it through `cn()` runs it
  // through tailwind-merge, which sees the `text-*` prefix as a typography
  // utility and strips it whenever the consumer also passes a
  // `text-<size>` class (e.g. `text-body-16`). Keep the glyph class on
  // its own so tailwind-merge can still de-dupe the consumer-provided
  // utilities without touching the icon name.
  <i className={`${cn('ico', className)} ${name}`} />
);
